// Place in src/components/permitForms/ConnectedCharacterInputs.jsx.
import React from "react";
import { TextField } from "@mui/material";
import { getConnectionInputError } from "../../utils/fieldConnections";

export default function ConnectedCharacterInputs({
  sources = [],
  values = {},
  onChange,
  disabled = false,
}) {
  if (!sources.length) return null;
  return (
    <>
      {sources.map((field) => {
        const value = values[field.name] ?? field.value ?? "";
        const error = getConnectionInputError(field, value);
        return (
          <TextField
            key={field.name}
            fullWidth
            variant="filled"
            margin="normal"
            type="text"
            name={field.name}
            label={field.label}
            required={Boolean(field.required)}
            disabled={disabled}
            value={value}
            onChange={(event) => onChange(field.name, event.target.value)}
            error={Boolean(error)}
            helperText={error || undefined}
          />
        );
      })}
    </>
  );
}
